module.exports = __webpack_public_path__ + "img/Persiapan.f65aef94.svg";